export default __webpack_public_path__ + "static/media/Oswald-Bold.4cc74cc0.ttf";